<template>
    <div class="app">
        <SignInPC v-if="isPC" :isBView="isBView"/>
        <SignInH5 v-else :isBView="isBView"/>
    </div>
</template>
<script>
    import SignInH5 from '../components/h5';
    import SignInPC from '../components/pc';
    import { enableAppShare } from '../../../common/js/APP/share';
    import { getCookie, setCookie } from '../../../uitl/getParam.js';
    import { fetchQueryFNNew } from '@/service/api'
    export default {
        name: 'Index',
        components: {
            SignInH5,
            SignInPC,
        },
        data() {
            return {
                isBView:'A',//A版      B版 
            };
        },
        mounted() {
            enableAppShare({
                title: '必看！入行人工智能的最佳时机',
                desc: '抢先站在AI红利风口，提前收获高薪职位',
                imgUrl: 'https://s21.lgstatic.com/growth/activity/20210419/1618812544956.png'
            });
            this.getPageFn();
        },
        methods: {
            getPageFn() { 
                const page_key = 'AI';
                if (!this.isApp) {
                    let page = JSON.parse(getCookie(page_key));
                    if (!page) {
                        page = {}
                        page.pageType = Math.ceil(Math.random() * 2)
                        setCookie(page_key, JSON.stringify(page))
                    } 
                    this.isBView = page.pageType == 2 ? 'B' : 'A';
                    return 
                } 
                let params = {
                    pageMark: page_key,//AI 
                }
                fetchQueryFNNew(params).then(res => {
                    if(res.state == 1) {
                        if(res.content) { //命中页面 不返回值 
                            this.isBView = 'B';
                        } else { //未命中 走a版
                            this.isBView = 'A'
                        } 
                    } else {
                        this.isBView = 'A'  //默认a版  报错a版
                    }
                }).catch(error => {
                    this.isBView = 'A'  //默认a版  报错a版
                });
            }, 
        },
    };
</script>
<style lang="less" scoped>
    .app {
        overflow-x: hidden;
    }
</style>
